"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CAMPAIGN_ANSWERS = exports.DEVICE_ID = exports.TOKEN = exports.USER_DATA = exports.HAS_CHOOSE_LOCALE = exports.USER_LNG = exports.APPSFLYER_ADSET_ID = exports.APPSFLYER_C = exports.APPSFLYER_PID = exports.APPSFLYER_ID = void 0;
// AppsFlyer
var APPSFLYER_ID = 'afUserId'; // generated by AppsFlyer
// These cookies are set in GTM
// https://tagmanager.google.com/#/container/accounts/149416033/containers/1777177/workspaces/1000134/tags

exports.APPSFLYER_ID = APPSFLYER_ID;
var APPSFLYER_PID = 'appsFlyer_pid';
exports.APPSFLYER_PID = APPSFLYER_PID;
var APPSFLYER_C = 'appsFlyer_c';
exports.APPSFLYER_C = APPSFLYER_C;
var APPSFLYER_ADSET_ID = 'appsFlyer_af_adset_id'; // userLng

exports.APPSFLYER_ADSET_ID = APPSFLYER_ADSET_ID;
var USER_LNG = 'userLng';
exports.USER_LNG = USER_LNG;
var HAS_CHOOSE_LOCALE = 'hasChooseLocale'; // userData

exports.HAS_CHOOSE_LOCALE = HAS_CHOOSE_LOCALE;
var USER_DATA = 'userData'; // token

exports.USER_DATA = USER_DATA;
var TOKEN = 'token'; // deviceID

exports.TOKEN = TOKEN;
var DEVICE_ID = 'deviceID';
exports.DEVICE_ID = DEVICE_ID;
var CAMPAIGN_ANSWERS = 'campaignAnswers';
exports.CAMPAIGN_ANSWERS = CAMPAIGN_ANSWERS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@snapask/common-components/dist/constants/cookieNames.js
// module id = 97
// module chunks = 33